// Not sure why we have so many question types defined as only the
// uncommented types are actually created by the service - just commented out for now
export enum QuestionType {
  DocumentType = 0, 
  DocumentFormat = 1,
  Airport = 2,
  //Nationality = 3,
  //IssuingCountry = 4
}
